module.exports = __webpack_public_path__ + "media/steps/carq_spinner_2-e3eca18f.png";